<template>
  <div class="order-page-wrapper">
    <van-nav-bar
      title="支付"
      fixed
      placeholder
      left-arrow
      @click-left="onClickLeft"
    />
    <section class="order-page-content">
      <div class="order-detail-card">
        <div class="detail-card-title">
          {{ detailInfo.name }}
        </div>
        <div class="detail-card-content">
          <div class="sites-wrapper">
            <div class="car-label" v-if="detailInfo['is_ticket'] == 0">日次</div>
            <div class="car-label" v-else="detailInfo['is_ticket'] == 1">日次 补票</div>
            <div class="start-site">
              {{ detailInfo['origin_address'] }}
            </div>
            <div class="end-site">
              {{ detailInfo['end_address'] }}
            </div>
            <div class="site-time">
              <i class="iconfont icon-rili"></i>
              <span>{{ `${detailInfo['origin_time']} - ${detailInfo['end_time']}` }}</span>
            </div>
            <div class="car-number">
              <i class="iconfont icon-chepai"></i>
              <span>{{ detailInfo['car_number'] }}</span>
            </div>
            <div class="site-user-info">
              <span style="margin-right: 10px;">{{ detailInfo['ride_date'] }}</span>
              <!--<span style="margin-right: 10px;">￥{{ detailInfo.amount }}</span>-->
              <span style="margin-right: 10px;">
                <!--{{
                  detailInfo['shuttle_type'] === 3 ? 51 : detailInfo['shuttle_type'] === 2 ? 65 : 55
                }}-->{{ detailInfo['seat_number']}}座
              </span>
            </div>

            <div class="ticket-footer">
              <div class="ticket-row">
                <div class="label">车票数量</div>
                <div class="value">总计: 1张</div>
              </div>
              <div class="ticket-row">
                <div class="label">订单总价</div>
                <div class="value ticket-price">￥{{ detailInfo.amount }}</div>
              </div>

              <div class="ticket-row">
                <div class="label">支付金额</div>
                <div class="value ticket-price">￥{{ detailInfo.amount }}</div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="order-detail-card">
        <div class="detail-card-title">
          支付方式
        </div>
        <div class="detail-card-content">
          <template v-for="(item,index) in payCategoryList">
            <div class="payable-ways" :key="index" @click="handleSelect(index)">
              <div class="payable--item">
                <div class="payable--label">
                  <i :class="`iconfont icon-${item.icon}`"></i>
                  {{ item.name }}
                </div>
                <div class="payable--value">
                  <span class="price" v-show="index === 1 && balance > 0">余额 ￥{{ balance }}</span>
                  <Selected class="select-icon" :name="index"
                            :status="item.status" />
                </div>
              </div>
            </div>
          </template>

          <!--          <div class="payable-ways">
                      <div class="payable&#45;&#45;item">
                        <div class="payable&#45;&#45;label">
                          <i class="iconfont icon-shouzhimingxicaifuhongbaoyue"></i>
                          余额
                        </div>
                        <div class="payable&#45;&#45;value">
                          <span class="price">余额 ￥0.00</span>
                          <Selected class="select-icon" key="2" :name="1"
                                    :status="radioGroup[1]" @select="handleSelect"/>
                        </div>
                      </div>
                    </div>-->
        </div>
      </div>
    </section>

    <section class="pay-order-button safe-area-bottom">
      <div class="pay-tips">
        <i class="iconfont icon-shield"></i>
        订单将在 <span class="last-time">{{ countdown }}</span> 后失效
      </div>
      <form id="form" action="https://pay.info.bit.edu.cn/pay/prepay" method="POST" v-if="payType === 0">
        <input type="text" style="display: none" :value="payInfo.productBody" name="productBody">
        <input type="text" style="display: none"
               :value="payInfo.productDetail" name="productDetail">
        <input type="text" style="display: none"
               :value="payInfo.sign" name="sign">
        <input type="text" style="display: none"
               :value="payInfo.spbillCreateIp" name="spbillCreateIp">
        <input type="text" style="display: none"
               :value="payInfo.tenant" name="tenant">
        <input type="text" style="display: none"
               :value="payInfo.tenantTradeNumber" name="tenantTradeNumber">
        <input type="text" style="display: none"
               :value="payInfo.tenantRedirectUrl" name="tenantRedirectUrl">
        <input type="text" style="display: none"
               :value="payInfo.tenantUserCode" name="tenantUserCode">
        <input type="text" style="display: none"
               :value="payInfo.tenantUserName" name="tenantUserName">
        <input type="text" style="display: none"
               :value="payInfo.timestamp" name="timestamp">
        <input type="text" style="display: none"
               :value="payInfo.totalFee" name="totalFee">
        <button type="submit" class="pay-button" @click="handlePay">
          支付￥{{ detailInfo.amount }}
        </button>
      </form>

     <button type="botton" class="pay-button" v-if="payType === 1" @click="balancePay">
          支付￥{{ detailInfo.amount }}
        </button>
    </section>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import * as dd from 'dingtalk-jsapi';
import Selected from '@/components/Selected.vue';
import Order from '@/apis/Order';
import time from '@/utils/time';
import Auth from '@/apis/Auth';
import md5 from 'js-md5';
// eslint-disable-next-line no-unused-vars
function openPostWindow(url, data) {
  // eslint-disable-next-line no-underscore-dangle
  const _data = {
    productBody: null,
    productDetail: null,
    sign: null,
    spbillCreateIp: null,
    tenant: null,
    tenantRedirectUrl: null,
    tenantTradeNumber: null,
    tenantUserCode: null,
    tenantUserName: null,
    timestamp: null,
    totalFee: null,
  };
  const tempForm = document.createElement('form');
  tempForm.id = 'tempForm1';
  tempForm.method = 'post';
  tempForm.action = url;
  tempForm.target = '_blank'; // _blank - URL加载到一个新的窗口

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const dataKey in _data) {
    _data[dataKey] = data[dataKey];
    const hideInput = document.createElement('input');
    hideInput.type = 'hidden';
    hideInput.name = dataKey;
    hideInput.value = data[dataKey];
    tempForm.appendChild(hideInput);
  }
  const submit = document.createElement('input');
  submit.type = 'submit';
  submit.style.display = 'none';
  submit.id = 'submitBtn';
  tempForm.appendChild(submit);
  document.body.appendChild(tempForm);
  submit.dispatchEvent(new Event('tap'));
  // 可以传多个参数
  /* var nextHideInput = document.createElement("input");
  nextHideInput.type = "hidden";
  nextHideInput.name = "content";
  nextHideInput.value = data;
  tempForm.appendChild(nextHideInput); */

  /* if (document.all) { // 兼容不同浏览器
    tempForm.attachEvent('onsubmit', () => {
    }); // IE
  } else {
    tempForm.addEventListener('submit', () => {
    }, false); // firefox
  }
  if (document.all) { // 兼容不同浏览器
    tempForm.fireEvent('onsubmit');
  } else {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('submit', false, true);
    tempForm.dispatchEvent(evt);
    tempForm.dispatchEvent(new Event('submit'));

    Toast.fail(11);
  } */
  document.body.removeChild(tempForm);
}

export default {
  components: { Selected },
  mixins: [time],
  name: 'detail',
  data() {
    return {
      detailInfo: {},
      show: false,
      canceling: false,
      bottomHeight: '73px',
      radioGroup: [true, false],
      payType: 0,
       balance: '0.00',
      payCategoryList: [
        {
          name: '在线支付',
          icon: 'weixinzhifu',
          key: 1,
          status: true,
        },
         {
           name: '余额',
           icon: 'shouzhimingxicaifuhongbaoyue',
           key: 2,
           status: false,
         },
      ],
      payInfo: {
        productBody: null,
        productDetail: null,
        sign: null,
        spbillCreateIp: null,
        tenant: null,
        tenantRedirectUrl: null,
        tenantTradeNumber: null,
        tenantUserCode: null,
        tenantUserName: null,
        timestamp: null,
        totalFee: null,
      },
    };
  },
  created() {
    this.queryData();
    this.$nextTick(() => {
      this.queryHeight();
    });
  },
  computed: {
    orderStatus() {
      return this.detailInfo?.order_status;
    },
    isEmpty() {
      return +this.detailInfo.id > 0;
    },
    statusName() {
      let res = '';
      switch (this.detailInfo?.order_status) {
        case 'created':
          res = '已预约';
          break;
        case 'cancel':
          res = '已取消';
          this.$router.replace('/orderDetail');
          break;
        case 'expired':
          res = '已失效';
          this.$router.replace('/orderDetail');
          break;
        case 'evaluation':
          res = '已评价';
          this.$router.replace('/orderDetail');
          break;
        default:
          res = '已支付';
          this.$router.replace('/orderDetail');
          break;
      }
      return res;
    },
    getHeaders(){
         const apikey = "oVw5lgBQ32mygdfZUvYuKAbYtm7DRN37";
          const apitime = new Date().getTime();
          const apitoken = md5(md5(apikey+apitime));
        return {'apitoken': apitoken,'apitime':apitime}
    }
  },
  methods: {
    async queryData() {
      const that = this;
      const userid = this.$store.getters['auth/userId'];
      if (userid.length) {
        const res = await Order.getDetail(this.$route.query && this.$route.query.id);
        const {
          code, data,
        } = res;
        if (Number(code) === 1) {
          // eslint-disable-next-line no-new
          new Promise((resolve) => {
            this.detailInfo = data;
             this.balance = data.balance;
          
            resolve(data);

          
             this.count(data['is_ticket']);
            
           

          }).then((resp) => {
            this.$axios.get(`${process.env.VUE_APP_BASE_API}/get-payinfo?id=${resp.id}&userid=${userid}`,{
             headers:that.getHeaders
           })
              .then((datas) => {
                // eslint-disable-next-line no-underscore-dangle
                const _res = datas.data;
                localStorage.setItem('res', JSON.stringify(datas));
                if (_res.code === '1') {
                  console.log(res);
                  this.payInfo = _res.data;
                  // openPostWindow('https://pay.info.bit.edu.cn/pay/prepay', res.data);
                } else {
                  Toast.fail(_res.message);
                }
              });
          });
        }
      } else {
        dd.ready(() => {
          dd.runtime.permission.requestAuthCode({
            corpId: 'ding5afe027889e9ac43acaaa37764f94726',
            onSuccess(result) {
              const { code } = result;
              Auth.login(code)
                .then((res) => {
                  if (res.code === '1') {
                    that.$store.commit('auth/setUserInfo', res?.data);
                    // eslint-disable-next-line max-len
                    that.$axios.get(`${process.env.VUE_APP_BASE_API}/get-order-info?userid=${res.data.userid}`)
                      .then((resp) => {
                        // eslint-disable-next-line no-underscore-dangle
                        const _resp = resp.data;
                        if (Number(_resp.code) === 1) {
                          that.detailInfo = _resp.data;
                          that.count();
                          that.$axios.get(`${process.env.VUE_APP_BASE_API}/get-payinfo?id=${that.detailInfo.id}&userid=${res.data.userid}`,{
             headers:that.getHeaders
           })
                            .then((datas) => {
                              // eslint-disable-next-line no-underscore-dangle
                              const _res = datas.data;
                              localStorage.setItem('res', JSON.stringify(datas));
                              if (_res.code === '1') {
                                console.log(res);
                                that.payInfo = _res.data;
                                // openPostWindow('https://pay.info.bit.edu.cn/pay/prepay', res.data);
                              } else {
                                Toast.fail(_res.message);
                              }
                            });
                        }
                      });
                  }
                })
                .catch((err) => {
                  console.error(err);
                });
            },
            onFail(err) {
              console.error('钉钉数据获取失败 ，', err);
            },
          });
        });
      }
    },
    async cancelOrder() {
      this.canceling = true;
      const toast = Toast.loading({
        message: '取消中',
        forbidClick: true,
      });
      const res = await Order.cancelOrder({ id: this.detailInfo.id });
      const {
        code,
        message,
      } = res;
      toast.clear();
      if (Number(code) !== 1) {
        this.canceling = false;
        Toast.fail(message);
        return;
      }
      Toast.success('取消预约成功');
      setTimeout(() => {
        this.$router.back();
      }, 2000);
    },
    queryHeight() {
      const bottom = document.querySelector('.utils-button-wrapper');
      this.bottomHeight = `${bottom?.clientHeight || 0}px`;
    },
    onClickLeft() {
      this.$router.back();
    },
    onCancelClick() {
      Dialog.alert({
        title: '提示',
        message: '确认取消预约？',
        showCancelButton: true,
      })
        .then(() => {
          this.cancelOrder();
        });
    },
    onEvaluation() {
      this.$router.push({
        path: '/evaluation',
        query: {
          id: this.detailInfo.id,
        },
      });
    },
    handleSelect(payindex) {
    
      this.payType = payindex;
      // this.radioGroup[name] = true;
      this.payCategoryList = this.payCategoryList.map((it, index) => ({
        ...it,
        status: index === payindex,
      }));
    },
    balancePay(){
         const userid = this.$store.getters['auth/userId'];
         
           this.$axios.get(`${process.env.VUE_APP_BASE_API}/balance-pay?id=${this.detailInfo.id}&userid=${userid}`,{
             headers:this.getHeaders
           }).then((datas) => {
                              const _res = datas.data;
                              if (_res.code === '1') {
                                Toast.success('支付成功');

                                setTimeout(() => {
                      this.$router.push({
                           path: '/orderDetail',
													query:{
														id:this.detailInfo.id
													}
                        });
                  
                       }, 2000);
                              
                               
                              } else {
                                Toast.fail(_res.message);
                              }
                            });
    },
    // eslint-disable-next-line consistent-return
    handlePay() {
     
      if (!this.payInfo.sign.length) {
        Toast.fail('获取配置失败');
        return false;
      }

      /* console.log({
        id: this.detailInfo.id,
        userid,
      }); */

      // Toast.fail('2222');
      // eslint-disable-next-line max-len
      /* this.$axios.get(`${process.env.VUE_APP_BASE_API}/get-payinfo?id=${this.detailInfo.id}&userid=${userid}`)
        .then((data) => {
          Toast.fail(1111111111);
          const res = data.data;
          localStorage.setItem('res', JSON.stringify(data));
          if (res.code === '1') {
        
            this.payInfo = res.data;
            openPostWindow('https://pay.info.bit.edu.cn/pay/prepay', res.data);
          } else {
            Toast.fail(res.message);
          }
        }); */
      /* Order.pay({
        id: this.detailInfo.id,
        userid,
      }).then((data) => {
         Toast.fail(222222222);
        localStorage.setItem('res', JSON.stringify(data));
        if (data.code === '1') {
          openPostWindow('https://pay.info.bit.edu.cn/pay/prepay', data.data, '_blank');
          // window.open(, '_self');
        } else {
          Toast.fail(data.message);
        }
      }).catch(() => {
        Toast.fail(111);
      }); */
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";

.order-page-content {
  padding: 10px 15px;
}

.order-detail-card {
  box-sizing: border-box;
  margin-bottom: 10px;

  .detail-card-title {
    background-color: #e8e8e8;
    height: 38px;
    line-height: 38px;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    font-size: 1rem;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    font-family: PingFang SC;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .detail-card-content {
    background-color: #fff;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    padding: 5px 10px;
  }
}

.sites-wrapper {
  position: relative;

  .start-site, .end-site {
    font-size: 12px;
    height: 28px;
    line-height: 28px;
  }

  .start-site {
    color: #808080;
    margin-left: 10px;
    position: relative;
    @include start-site(4.5px);
  }

  .end-site {
    color: #808080;
    position: relative;
    margin-left: 10px;
    @include end-site(4.5px);
  }
}

.pay-order-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 15px;
  padding-right: 15px;
  background: #fff;
  padding-top: 10px;
  @include safe-padding-bottom(20px);
}

.site-time {
  color: #999999;
  display: flex;
  align-items: center;

  .icon-rili {
    font-size: 16px;
    margin-right: 4px;
    color: #45a3ff;
  }
}

.car-number {
  color: #999999;
  font-size: 12px;
  display: flex;
  align-items: center;

  .icon-chepai {
    color: #fc588a;
    font-size: 16px;
    margin-right: 5px;
  }
}

.car-label {
  position: absolute;
  right: 0;
  top: 10px;
  color: #ff432f;
  border: 1.4px solid #ff432f;
  padding: 0 5px;
  font-size: 12px;
  border-radius: 4px;
}

.ticket-footer {
  border-top: 0.7px solid #f3f3f3;
  padding-top: 10px;

  .ticket-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999999;
    height: 26px;
    line-height: 26px;

    .ticket-price {
      color: #ff432f;
    }
  }
}

.pay-tips {
  color: #999999;
  line-height: 30px;
  display: flex;
  align-items: center;

  .icon-shield {
    font-size: 20px;
    color: #f40;
  }

  .last-time, .pay-notice-icon {
    color: #fe0000;
  }

  .pay-notice-icon {
    font-size: 18px;
    margin-right: 5px;
  }
}

.pay-button {
  width: 100%;
  background: #1a6b45;
  border-radius: 4px;
  height: 35px;
  border: none;
  color: #fff;
}

.site-user-info {
  color: #ff432f;
  height: 30px;
  line-height: 30px;
  padding-bottom: 4px;
}

.payable-ways {
  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }

  .payable--item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #757575;
    height: 40px;
    line-height: 40px;

    .payable--label {
      display: flex;
      align-items: center;

      .icon-weixinzhifu {
        color: #2ba245;
        font-size: 23px;
        margin-right: 5px;
      }

      .icon-shouzhimingxicaifuhongbaoyue {
        color: #ffc500;
        font-size: 23px;
        margin-right: 5px;
      }
    }

    .payable--value {
      display: flex;
      align-items: center;
      .select-icon {
        margin-left: 5px;
      }
    }
  }
}
</style>
